// Moving this out of the FANTASY_CONSTANTS since 'lodash' used in fantasy/constants.ts
// unnecessarily adds external dependency (lodash) to the ecs-consumer fargate container
export const FANTASY_SEASON: number = 2024
